import NewController, { NewControllerInterface } from "csi/action/NewController";
import { FormStore, NewFormDialog } from "csi/middleware/form/index";
import reflection from "csi/reflection";
import { routerStore } from "csi/state/rootStore";
import declare from "dojo/_base/declare";
import { getFormStateByNodeType, IGetForm } from "src/c8-platform/service/formService";
import { FormFieldInitialValueMap } from "src/c8-platform/type/form";
import { DUMMY } from "src/c8-platform/type/node";
import { cnl } from "src/c8-platform/type/value";
import NewMixin from "./NewMixin";

const New = declare([NewController, NewMixin], {
	/**
	 * @override
	 * Use react form if so configured; otherwise call mixin for any preprocessing
	 */
	preProcess(): void {
		if (this.useReactForm) {
			this.preProcessReactForm();
			return;
		}

		if (this._newPreProcess()) {
			this.inherited(arguments);
		}
	},

	/** 
	 * pre-processing for the new React form 
	 */
	preProcessReactForm(): void {
		// NOTE: Same as csi/table/New - try to consolidate
		const {
			m_action: { m_typeNode },
			m_idAttrParent,
			m_urlNode,
		} = this;

		let {
			m_urlContext: contextUrl,
			m_urlParent: parentUrl,
		} = this;

		this.suspendProcess();
		const canRepeat = this._canRepeat();
		const canNavigate = this._canNavigate();

		// specify initial values if needed
		// NOTE: leave it for reference
		// const initialValueMap: FormFieldInitialValueMap = {
		// 	test: "Hello World",
		// };

		const relation = reflection.getRelation(this.getParent(), m_idAttrParent);

		if (relation?.isComposite) {
			// composite case, the parent is the real parent

		} else if (!m_idAttrParent) {
			// if m_idAttrParent is null, that means the view is global view
			contextUrl = parentUrl;
			parentUrl = DUMMY;
		} else {
			// non-composite case, we need to help with specify the appropriate parent 
		}

		const form: IGetForm = {
			contextUrl,
			// initialValueMap,
			nodeType: m_typeNode,
			nodeUrl: m_urlNode,
			parentAttributeId: m_idAttrParent,
			parentUrl,

			// in the case of new, the source node is null
			sourceNodeUrl: "",
		};

		const formInfo = getFormStateByNodeType(form);

		const processFormCallback = (formNodeCNL: cnl, bNavigate: boolean, bRepeat: boolean): void => {
			this.m_urlNode = formNodeCNL;
			const controller = this as NewControllerInterface;
			controller.bNavigate = bNavigate;
			this.repeatReactForm = bRepeat;
			this.resumeProcess();
			this.postProcess(true);
		};

		const processCancelFormCallback = (): void => {
			this.repeatReactForm = false;
			this.onCancelReactDialog();
		};

		formInfo.then((formInfo) => {
			const cache = this.getCache();
			const store = new FormStore(
				cache,
				formInfo,
				processFormCallback,
				processCancelFormCallback,
				canNavigate,
				canRepeat,
			);

			this.useReactDialog(routerStore.openDialog(NewFormDialog, { store, title: this.getTitle() }));
		});
	},
	
	/**
	 * @override if operating on table rows, then call mixin before continuing; if not, then 
	 * refresh row by default if no other processing done
	 */
	postProcessSuccess() {
		if (!this.bNavigate && this.bRefNode) {
			this._newPostProcess();
		}

		var	dfd = this.inherited(arguments);

		if (!this.bNavigate && !this.bRefNode && !dfd) {
			// reset m_element after refreshNode so if action is repeated it will continue to work
			var	view = this.widget;
			var	refNode = view.getRefNode(this.m_element);
			var	id = view.getRefNodeId(refNode);
			if (id != null) {
				view.redrawNode(refNode);
				this.m_element = view.getRefNodeById(id);
			}
		}

		return dfd;
	},

	/**
	 * @override
	 * if action invoked from action link, then reset to null so it will be appended to end
	 */
	_setRefNode(refNode: HTMLElement): void {
		if (!this.widget.isRefNode(refNode, true)) {
			refNode = null;
		}
		
		this.inherited(arguments, [refNode]);
	},
});

export = New;